import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=75ba4426&scoped=true&"
import script from "./Inbound.vue?vue&type=script&lang=js&"
export * from "./Inbound.vue?vue&type=script&lang=js&"
import style0 from "./Inbound.vue?vue&type=style&index=0&id=75ba4426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ba4426",
  null
  
)

export default component.exports